import React from "react";
import FridgePageTemplate from "./FridgePageTemplate";

const relatedLinks = [
  { to: "/fridge-service-bangalore", label: "Refrigerator Service" },
  { to: "/fridge-not-cooling-repair", label: "Fridge Not Cooling" },
  { to: "/fridge-compressor-repair", label: "Compressor Repair" },
  { to: "/fridge-ice-buildup-repair", label: "Ice Buildup Repair" },
  { to: "/fridge-water-leak-repair", label: "Water Leak Repair" },
];

const FridgeFreezerCoolingIssue = () => {
  return (
    <FridgePageTemplate
      title="Freezer Cooling Issue Repair in Bangalore"
      description="Expert freezer cooling issue repair in Bangalore for frost, compressor, and airflow problems in refrigerator freezers."
      keywords="freezer cooling issue repair bangalore, refrigerator freezer repair, freezer not cold"
      path="/freezer-cooling-issue"
      bannerTitle="Freezer Cooling Issue"
      intro={
        <>
          If the freezer compartment is not getting cold, our Bangalore technicians diagnose the cooling circuit, drain systems, and thermostat to restore freezer temperature.
        </>
      }
      highlights={[
        "Freezer cooling diagnostics",
        "Evaporator and thermostat checks",
        "Compressor and refrigerant inspection",
        "Fast freezer repair service",
      ]}
      issues={[
        "Freezer not freezing",
        "Ice buildup in freezer compartment",
        "Freezer temperature too high",
        "Cold air not circulating",
      ]}
      relatedLinks={relatedLinks}
    />
  );
};

export default FridgeFreezerCoolingIssue;

